import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { ResourceDirectory } from './components/ResourceDirectory';
import { NewsSection } from './components/NewsSection';
import { EventsCalendar } from './components/EventsCalendar';
import { NextMeeting } from './components/NextMeeting';
import { OfficialResources } from './components/OfficialResources';
import { TranslationProvider } from './components/TranslationProvider';
import { ServiceNotice } from './components/ServiceNotice';
import { LiveTraffic } from './components/LiveTraffic';
import { WeatherBanner } from './components/WeatherBanner';
import { FloatingContact } from './components/FloatingContact';
import { Facebook, Instagram } from 'lucide-react';
export function App() {
  return <TranslationProvider data-id="element-0">
      <div id="top" className="min-h-screen font-sans text-gray-900 bg-white selection:bg-sky selection:text-white" data-id="element-1">
        <Navbar data-id="element-2" />
        {/* Aviso de servicios oficiales (inglés/español) — debajo del encabezado */}
        <ServiceNotice data-id="element-3" />
        <WeatherBanner data-id="element-4" />
        <main data-id="element-5">
          <Hero data-id="element-6" />

          {/* Directorio Telefónico Digital y Accesible (Reemplaza al libro 3D) */}
          <ResourceDirectory data-id="element-7" />

          <NewsSection data-id="element-8" />
          <LiveTraffic data-id="element-9" />
          <EventsCalendar data-id="element-10" />
          <NextMeeting data-id="element-11" />
          <OfficialResources data-id="element-12" />
        </main>

        <footer className="bg-charcoal-dark text-softblue-dark py-12 text-center text-sm border-t-4 border-sylmar" data-id="element-13">
          <div className="max-w-4xl mx-auto px-6 flex flex-col items-center" data-id="element-14">
            <div className="flex items-center justify-center gap-3 mb-8" data-id="element-15">
              <img src="https://cdn.magicpatterns.com/uploads/b19k3B7qcY9GvykkPkXLub/ChatGPT_Image_2_jul_2026,_00_15_36.png" alt="Sylmar Neighborhood Council" className="h-16 brightness-200 notranslate" data-id="element-16" />
            </div>

            {/* Redes Sociales Oficiales */}
            <div className="flex gap-6 mb-8" data-id="element-17">
              <a href="https://www.facebook.com/sylmarnc/" target="_blank" rel="noopener noreferrer" className="bg-[#1877F2] text-white p-3.5 rounded-full hover:scale-110 transition-transform shadow-lg" aria-label="Facebook Oficial" data-id="element-18">
                <Facebook className="w-6 h-6 fill-current" data-id="element-19" />
              </a>
              <a href="https://www.instagram.com/sylmar_nc?igsh=NTc4MTIwNjQ2YQ%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#8134AF] text-white p-3.5 rounded-full hover:scale-110 transition-transform shadow-lg" aria-label="Instagram Oficial" data-id="element-20">
                <Instagram className="w-6 h-6" data-id="element-21" />
              </a>
            </div>

            <p className="text-gray-400" data-id="element-22">
              © {new Date().getFullYear()}{' '}
              <span className="notranslate" data-id="element-23">Sylmar Neighborhood Council</span>.
              Todos los derechos reservados.
            </p>
          </div>
        </footer>

        {/* Widget Flotante de Contacto */}
        <FloatingContact data-id="element-24" />
      </div>
    </TranslationProvider>;
}